const Constants = {
  WORKFLOW_APPLICATION_TEXT: 'Download Application',
  MESSAGE_READ_STATUS_TEXT: 'Read'
};

export default Constants;